// Action types for fetching orders
export const FETCH_SYNC_META_REQUEST = 'FETCH_SYNC_META_REQUEST';
export const FETCH_SYNC_META_SUCCESS = 'FETCH_SYNC_META_SUCCESS';
export const FETCH_SYNC_META_FAILURE = 'FETCH_SYNC_META_FAILURE';
export const FETCH_SYNC_META_REST = 'FETCH_SYNC_META_REST';
// Fetch data actions
export const fetchStoreSyncMetaRequest = (payload) => ({
    type: FETCH_SYNC_META_REQUEST,
    payload,
});
export const fetchStoreSyncMetaSuccess = (payload) => ({
    type: FETCH_SYNC_META_SUCCESS,
    payload,
});
export const fetchStoreSyncMetaFailure = (error) => ({
    type: FETCH_SYNC_META_FAILURE,
    payload: error,
});
export const fetchStoreSyncMetaRest = () => ({
    type: FETCH_SYNC_META_REST,
});
